import type {Repository} from '@github-ui/agent-sessions-interface/components/repo-picker/repo'
import {useQuery} from '@github-ui/react-query'

import {fetchRepoFiles, type RepoFileTree} from './fetch-repo-files'

/**
 * Fetches the file tree of a repository using TanStack Query. The query is
 * only enabled when a repository is provided. Results are cached per-repo and
 * remain fresh for 60 seconds to avoid redundant requests when toggling the
 * file picker open/closed.
 */
export function useRepoFiles(repo: Repository | undefined) {
  const repoId = repo?.id
  const repoName = repo?.name

  return useQuery<RepoFileTree>({
    queryKey: ['copilot-repo-files', repoId, repoName],
    queryFn: ({signal}) => {
      if (!repoId || !repoName) throw new Error('No repository selected')
      return fetchRepoFiles(repoId, repoName, signal)
    },
    enabled: !!repoId && !!repoName,
    staleTime: 60_000,
  })
}
